import { useAmplitudeHelpStore } from './useAmplitudeHelpStore';
import { useEffect } from 'react';
import { useChannelMessage } from '../../channel-message/ChannelMessagingProvider';

function useAmplitudeRC(openAmplitudeRC: () => void) {
  const { isOpen, closeHelp, currentAppInView } = useAmplitudeHelpStore();
  useEffect(() => {
    if (isOpen) {
      if (currentAppInView === 'unify' && window.engagement?.rc?.open) {
        window.engagement.rc.open();
      } else if (currentAppInView !== 'unify') {
        openAmplitudeRC();
      }
    }
  }, [isOpen, currentAppInView,openAmplitudeRC]);

  useEffect(() => {
    if (!isOpen && currentAppInView === 'unify') {
      return;
    }
    const observer = new MutationObserver(() => {
      const resourceCenterEl = document.querySelector('#resource-center-modal');
      if (!resourceCenterEl) {
        closeHelp();
      }
    });
    if (isOpen) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
    return () => {
      if (isOpen) {
        observer.disconnect();
      }
    };
  }, [isOpen, closeHelp, currentAppInView]);

  useEffect(() => {
    function handleOutsideClick(event: any) {
      const resourceCenterEl = document.querySelector('#resource-center-modal');
      const triggerBtn = document.querySelector(
        '#resource-center-modal [title="Close"]'
      );
      if (
        currentAppInView === 'unify' &&
        resourceCenterEl &&
        !resourceCenterEl.contains(event.target)
      ) {
        if (triggerBtn && triggerBtn.contains(event.target)) {
          return;
        }
        if (window.engagement?.rc?.close) {
          window.engagement.rc.close();
        }
        if (closeHelp) {
          closeHelp();
        }
      }
    }
    document.addEventListener('click', handleOutsideClick, true);
    return () => {
      document.removeEventListener('click', handleOutsideClick, true);
    };
  }, [isOpen, closeHelp, currentAppInView]);
}


const AmplitudeRCContainer = () => {
  const { openAmplitudeRC } = useChannelMessage();
  useAmplitudeRC(openAmplitudeRC);
  return null;
};

export default AmplitudeRCContainer;
